export const SET_TASK_PENDING = 'SET_TASK_PENDING';
export const SET_TASK_FULFILLED = 'SET_TASK_FULFILLED';

/*
 * start something pending (signals global spinner)
 */
export const setTaskPending = () => ({
  type: SET_TASK_PENDING
});

/*
 * clear something pending (signals global spinner)
 */
export const setTaskFulfilled = () => ({
  type: SET_TASK_FULFILLED
});
